var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFreeTalkCategory = function SvgFreeTalkCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#free-talk-category_svg__a)",
    d: "M20.246 14.077c-6.47 0-11.715 5.246-11.715 11.715 0 3.042 1.16 5.813 3.062 7.896-.528 1.464-1.602 2.285-2.4 2.712-.336.18-.28.65.08.78.904.329 3.947.76 5.557-1a11.65 11.65 0 0 0 5.416 1.327c6.47 0 11.715-5.245 11.715-11.715s-5.245-11.715-11.715-11.715"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#free-talk-category_svg__b)",
    d: "M29.572 10.492c5.467 0 9.9 4.433 9.9 9.9 0 2.571-.98 4.913-2.586 6.672.445 1.238 1.353 1.93 2.028 2.292.283.152.235.55-.068.659-.765.277-3.336.642-4.696-.845a9.85 9.85 0 0 1-4.578 1.122c-5.468 0-9.9-4.432-9.9-9.9 0-5.467 4.432-9.9 9.9-9.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.835 21.509a1.116 1.116 0 1 0 0-2.232 1.116 1.116 0 0 0 0 2.232M29.436 21.509a1.116 1.116 0 1 0 0-2.232 1.116 1.116 0 0 0 0 2.232M25.038 21.509a1.116 1.116 0 1 0 0-2.232 1.116 1.116 0 0 0 0 2.232"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-talk-category_svg__a",
    x1: 10.498,
    x2: 27.065,
    y1: 18.973,
    y2: 35.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC42E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "free-talk-category_svg__b",
    x1: 22.81,
    x2: 37.81,
    y1: 14.5,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26700"
  })))));
};
export default SvgFreeTalkCategory;